
$(document).ready(function(){
	
	$("#topmenu a").on('click', function(e){
		show_loading();
	});	
		
});